import Cresta71 from './Cresta 7 (1).webp'
import Cresta72 from './Cresta 7 (2).webp'
import Cresta73 from './Cresta 7 (3).webp'
import Cresta74 from './Cresta 7 (4).webp'
import Cresta75 from './Cresta 7 (5).webp'
import Cresta76 from './Cresta 7 (6).webp'
import Cresta77 from './Cresta 7 (7).webp'
import Cresta78 from './Cresta 7 (8).webp'
import Cresta79 from './Cresta 7 (9).webp'
import Cresta710 from './Cresta 7 (10).webp'




const Cresta7images =[
Cresta71,Cresta72,Cresta73,Cresta74,Cresta75,Cresta76,Cresta77,Cresta78,Cresta79,Cresta710
]

export default Cresta7images;